import * as Sentry from "@sentry/gatsby";

Sentry.init({
    dsn: process.env.SENTRY_DNS,


    environment: process.env.NODE_ENV || 'development'
});